import { BiSolidCircle } from 'react-icons/bi';

export default function SoldIndicator() {
  return (
    <span
      style={{
        position: "absolute",
        bottom: "4px",
        right: "6px",
        color: "red",
        fontSize: ".5rem",
        zIndex: 2,
      }}
    >
      <BiSolidCircle />
    </span>
  );
}
